import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import Divider from "@mui/material/Divider";
import { getIntegrationLogById } from "../../../actions/integrationLogsActions";
import { formatDateDisplay } from '../../../utilities/dateFormats';
import { getIntegrationLogStatus } from "../../../constants/integrationConstants";
import style from "../../../blueTheme";

function IntegrationLogDetails(props) {
    const dispatch = useDispatch();
    const integrationLog = useSelector(state => state.integrationLog);

    useEffect(() => {
        if (props.id) {
            dispatch(getIntegrationLogById(props.id));
        }
    }, [props.id, dispatch]);

    const integrationLogCopy = {...integrationLog};
    let integrationEvent;
    
    if (Object.entries(integrationLogCopy).length > 0) {
        integrationEvent = {...integrationLogCopy.integrationEvent};
        integrationEvent.message = JSON.parse(integrationEvent.message);
    }

    const rootStyle = {
        font: style.palette.font,
        padding: "3%",
        justifyContent: "space-between",
        width: "94%",
        maxHeight: "fit-content",
        height: "fit-content",
        minHeight: "fit-content",
        ...props.style
    };

    // BRC Commented out was created a mutation error and causing closeDrawer to fail on first click
    // if (integrationLog.integrationEvent !== undefined) {
    //     delete integrationLog.integrationEvent.integration['apiKey1'];
    //     delete integrationLog.integrationEvent.integration['apiKey2'];
    // }

    return (
        (integrationLogCopy && integrationLogCopy.hasOwnProperty('integrationEvent')) ?
            <div style={rootStyle}>
                <div id="IntegrationLogDetails-EventDate-container-div" style={{width: "100%", display: "flex"}}>
                    <div style={{paddingBottom: "12px", fontWeight: "400"}}>{"Event date:"}</div>
                    <div style={{width: "15px"}}/>
                    <div style={{
                        float: "left",
                        paddingBottom: "12px",
                        fontSize: "16px",
                        fontWeight: "500"
                    }}>{formatDateDisplay(integrationLogCopy.createdDate, "DATETIME")}</div>
                </div>
                <div id="IntegrationLogDetails-Title-container-div" style={{width: "100%", display: "flex"}}>
                    <div style={{paddingBottom: "12px", fontWeight: "400"}}>{"Title:"}</div>
                    <div style={{width: "15px"}}/>
                    <div style={{
                        paddingBottom: "12px",
                        fontSize: "16px",
                        fontWeight: "500"
                    }}>{integrationLogCopy.integrationEvent.integration.name}</div>
                </div>
                <div id="IntegrationLogDetails-Questionnaire-container-div"
                    style={{width: "100%", display: "flex"}}>
                    <div style={{paddingBottom: "12px", fontWeight: "400"}}>{"Questionnaire:"}</div>
                    <div style={{width: "15px"}}/>
                    <div style={{
                        paddingBottom: "12px",
                        fontSize: "16px",
                        fontWeight: "500"
                    }}>{integrationLogCopy.integrationEvent.questionnaire.questionnaireTemplate.name}</div>
                </div>
                <div id="IntegrationLogDetails-TrackingId-container-div" style={{width: "100%", display: "flex"}}>
                    <div style={{paddingBottom: "12px", fontWeight: "400"}}>{"Tracking Id:"}</div>
                    <div style={{width: "15px"}}/>
                    <div style={{
                        paddingBottom: "12px",
                        fontSize: "16px",
                        fontWeight: "500"
                    }}>{integrationLogCopy.integrationEvent.trackingId}</div>
                </div>
                <div id="IntegrationLogDetails-ResponseId-container-div" style={{width: "100%", display: "flex"}}>
                    <div style={{paddingBottom: "12px", fontWeight: "400"}}>{"Response Id:"}</div>
                    <div style={{width: "15px"}}/>
                    <div style={{
                        paddingBottom: "12px",
                        fontSize: "16px",
                        fontWeight: "500"
                    }}>{integrationLogCopy.responseId}</div>
                </div>
                <div id="IntegrationLogDetails-Result-container-div" style={{width: "100%", display: "flex"}}>
                    <div style={{paddingBottom: "12px", fontWeight: "400"}}>{"Result:"}</div>
                    <div style={{width: "15px"}}/>
                    <div style={{
                        paddingBottom: "12px",
                        fontSize: "16px",
                        fontWeight: "500"
                    }}>{getIntegrationLogStatus[integrationLogCopy.success ? 1 : 0]}</div>
                </div>
                <div id="IntegrationLogDetails-ResultMessage-container-div"
                    style={{width: "100%", display: "flex"}}>
                    <div style={{paddingBottom: "12px", fontWeight: "400"}}>{"Result Message:"}</div>
                    <div style={{width: "15px"}}/>
                    <div style={{
                        paddingBottom: "12px",
                        fontSize: "16px",
                        fontWeight: "500"
                    }}>{integrationLogCopy.resultMessage}</div>
                </div>
                <div id="IntegrationLogDetails-ResponseTime-container-div" style={{width: "100%", display: "flex"}}>
                    <div style={{paddingBottom: "12px", fontWeight: "400"}}>{"Response Time (ms):"}</div>
                    <div style={{width: "15px"}}/>
                    <div style={{
                        paddingBottom: "12px",
                        fontSize: "16px",
                        fontWeight: "500"
                    }}>{integrationLogCopy.responseTime}</div>
                </div>

                <div style={{width: "40%"}}>
                    <div style={{paddingBottom: "12px", fontSize: "16px", fontWeight: "500"}}>{" "}</div>
                </div>

                <div style={{width: "40%"}}>
                    <div style={{
                        fontSize: "16px",
                        fontWeight: "500"
                    }}>{"Event Message:"}</div>
                </div>

                <pre style={{width: "100%", fontSize: "16px"}}>
                    {JSON.stringify(integrationEvent.message, null, 4)}
                </pre>

                <div style={{width: "40%"}}>
                    <div style={{paddingBottom: "0px", fontSize: "12px", fontWeight: "500"}}>{"\u00A0"}</div>
                </div>

                <div style={{width: "40%"}}>
                    <div style={{
                        fontSize: "16px",
                        fontWeight: "500"
                    }}>{"Event Details:"}</div>
                </div>

                <pre style={{width: "100%", fontSize: "16px"}}>
                    {JSON.stringify(integrationEvent, null, 4)}
                </pre>

                <div>&nbsp;</div>

                <Divider style={{
                    height: "100%",
                    minWidth: "2px",
                    marginRight: "8px",
                    marginLeft: "8px",
                    backgroundColor: "rgb(97, 97, 97, .8)"
                }}/>
            </div>
            : ""
    );
}

IntegrationLogDetails.defaultProps = {
    integrationLog: undefined
};

IntegrationLogDetails.propTypes = {
    id: PropTypes.number,
};

export default IntegrationLogDetails;